import { VFC } from 'react';

import { Report } from 'dashboard/models/report';
import ResourceReport from 'dashboard/modules/ResourceReport';

interface RelatedReportsProps {
  reports: Report[];
}

const RelatedReports: VFC<RelatedReportsProps> = ({ reports }) => (
  <>
    {reports.map((report) => (
      <ResourceReport
        key={report.id}
        defaultAccordionOpen={false}
        report={report}
        // TODO(zixiao): pass in reportTemplate
        reportTemplate={undefined}
        featureFlags={{}}
      />
    ))}
  </>
);

export default RelatedReports;
